module.exports = __webpack_public_path__ + "img/savology-user-flow.ae745c49.png";